module.exports = __webpack_public_path__ + "img/title-icon1.172e1b1a.png";